<template>
    <!-- 联级下拉框 -->
    <el-cascader
            v-if="showCascader"
            :disabled="disabled"
            v-model="formData[c.key]"
            :placeholder="placeholder"
            ref="cascader"
            clearable
            collapse-tags
            :show-all-levels="showAllLevels"
            @change="$emit('cascaderChange')"
            :props="initCascaderProp()"></el-cascader>
</template>

<script>
    import publicAPI from '../../api-path/public-api'
    export default {
        name: "cascader",
        props: ['disabled', 'c', 'showAllLevels','placeholder', 'formData'],
        data() {
          return {
              leaf: '',
              showCascader: true,
              isTrue:false,
              areaTreeListResList:[],
              num:0,
          }
        },

        methods: {
            // 初始化联级下拉的配置
            initCascaderProp() {
                let props = {
                    multiple: false,
                    value: 'id',
                    label: 'name',
                    lazy: this.c.config.lazy === false ? false : true,
                    lazyLoad: this.lazyLoad,
                    checkStrictly: this.c.config &&  this.c.config.checkStrictly ? this.c.config.checkStrictly : false
                }
                this.leaf = this.c.config &&  this.c.config.level ? this.c.config.level : false
                props = {...props, ...this.c.option}
                return props
            },
            // 连级查询
            lazyLoad(node, resolve) {
                const {level} = node;
                let keyValue
                let requestPath = this.c.path || publicAPI.areaListTree
                let params = {}
                if(this.c.params) {
                    this.c.params =  this.c.params.replace(/\s+/g,"")
                     keyValue = this.c.params.split(':')
                     params = {
                        [keyValue[0]]: node.data ? node.data[keyValue[1]] : this.c.defultParams
                    }
                }

                if(this.num!=1){
                    this.$http.get(requestPath, {params: params}).then(res => {
                        if (res.status === 200) {
                            if (res.result) {
                                this.num+=1;
                                let result=[]
                                this.areaTreeListResList=res.result.areaTreeListResList;
                                if(this.num>1){
                                    result=res.result.areaTreeListResList
                                }else {
                                    result=[res.result]
                                }
                                result.map(item => {
                                    if (this.leaf) {
                                        item.leaf = level >= this.leaf ? true : false
                                    }
                                })
                                resolve(result)
                            } else {
                                resolve()
                            }
                        }
                    })
                }else {
                    this.num+=1;
                    resolve(this.areaTreeListResList)
                }

            },
        }
    }
</script>

<style scoped>

</style>
